package cz.vojtechhoranek.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import cz.vojtechhoranek.site.localization.BrowserLanguage
import kotlinx.browser.window
import org.jetbrains.compose.web.css.vh


@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = window.preferredColorMode
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        ColorSchemeEffect()

        Surface(
            SmoothColorStyle.toModifier()
                .scrollBehavior(ScrollBehavior.Smooth)
        ) {
            Box(Modifier.minHeight(100.vh)) {
                BrowserLanguage {
                    content()
                }
            }
        }
    }
}
